export default {
  FAQ_btn: 'Помощь',
  privacyPolicy_btn: 'Политика конфиденциальности',
  impressum_btn: 'Контакты',
  contact_us_btn: 'Связаться с нами',
}



// WEBPACK FOOTER //
// ./src/locale/ru-RU/login.js